import { ChatbotAssistantTypes } from './types';

interface CreateUserChatMessageParamsTypes {
  content: string;
  assistant_user_chat_id?: number | null;
}

interface FetchUserChatMessagesParams {
  assistant_user_chat_id: number;
  is_current_chat?: boolean;
}

export const fetchUserChatMessages = (params: FetchUserChatMessagesParams) => {
  const { assistant_user_chat_id, is_current_chat = false } = params;

  return {
    types: [
      ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHAT_MESSAGES_REQUEST,
      ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHAT_MESSAGES_SUCCESS,
      ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHAT_MESSAGES_FAILURE,
    ],
    promise: (client: any) =>
      client.get('/chatbots/chatbot_assistant/assistant_user_chat_messages', {
        params: { assistant_user_chat_id },
      }),
    assistant_user_chat_id,
    is_current_chat,
  };
};

export const createUserChatMessage = (
  createUserChatMessageParams: CreateUserChatMessageParamsTypes,
) => {
  const { content, assistant_user_chat_id = null } = createUserChatMessageParams;

  const params: CreateUserChatMessageParamsTypes = { content };

  if (assistant_user_chat_id && assistant_user_chat_id !== 0)
    params.assistant_user_chat_id = assistant_user_chat_id;

  return {
    types: [
      ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_MESSAGE_REQUEST,
      ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_MESSAGE_SUCCESS,
      ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_MESSAGE_FAILURE,
    ],
    promise: (client: any) =>
      client.post('/chatbots/chatbot_assistant/assistant_user_chat_messages', params),
    content,
  };
};

export const fetchUserChats = () => ({
  types: [
    ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHATS_REQUEST,
    ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHATS_SUCCESS,
    ChatbotAssistantTypes.FETCH_ASSISTANT_USER_CHATS_FAILURE,
  ],
  promise: (client: any) => client.get('/chatbots/chatbot_assistant/assistant_user_chats'),
});

export const createUserChat = () => ({
  types: [
    ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_REQUEST,
    ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_SUCCESS,
    ChatbotAssistantTypes.CREATE_ASSISTANT_USER_CHAT_FAILURE,
  ],
  promise: (client: any) => client.post('/chatbots/chatbot_assistant/assistant_user_chats'),
});

export const updateCurrentChatId = (current_chat_id: number | null) => ({
  type: ChatbotAssistantTypes.UPDATE_SELECTED_CHAT_ID,
  assistant_user_chat_id: current_chat_id,
});

export const updateUserChatMessage = (id: number, rating: boolean) => ({
  types: [
    ChatbotAssistantTypes.UPDATE_ASSISTANT_USER_CHAT_MESSAGE_REQUEST,
    ChatbotAssistantTypes.UPDATE_ASSISTANT_USER_CHAT_MESSAGE_SUCCESS,
    ChatbotAssistantTypes.UPDATE_ASSISTANT_USER_CHAT_MESSAGE_FAILURE,
  ],
  promise: (client: any) =>
    client.patch(`/chatbots/chatbot_assistant/assistant_user_chat_messages/${id}`, { rating }),
  message_id: id,
  rating,
});
